module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel",
    attrs: {
      "id": "page__noforwarding__report"
    }
  }, [_c('md-content', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('sort-table', {
    attrs: {
      "columns": _vm.tableColumns,
      "per-page": _vm.perPage,
      "total": _vm.reportsAmount,
      "table-id": "report-noforwarding",
      "default-order": "desc",
      "default-sort": "id",
      "showAddButton": false,
      "noBreackColumns": ['traking_number', 'id'],
      "refreshOnCreate": false
    },
    on: {
      "refresh": _vm.getReports
    },
    scopedSlots: _vm._u([{
      key: "weight",
      fn: function(scope) {
        return [(scope.item.weight) ? _c('span', [_vm._v(" " + _vm._s(scope.item.weight) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "size",
      fn: function(scope) {
        return [(scope.item.size) ? _c('span', [_vm._v(" " + _vm._s(scope.item.size) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "from",
      fn: function(scope) {
        return [(scope.item.from) ? _c('span', {
          attrs: {
            "clas": "no-break-hidden"
          }
        }, [_vm._v(" " + _vm._s(scope.item.from.value) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "to",
      fn: function(scope) {
        return [(scope.item.to) ? _c('span', {
          attrs: {
            "clas": "no-break-hidden"
          }
        }, [_vm._v(" " + _vm._s(scope.item.to.value) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "payer",
      fn: function(scope) {
        return [(scope.item.payer) ? _c('span', {
          staticClass: "no-break-hidden"
        }, [_vm._v(" " + _vm._s(scope.item.payer.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "payment_method",
      fn: function(scope) {
        return [(scope.item.payment_method) ? _c('span', [_vm._v(" " + _vm._s(scope.item.payment_method.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "nds",
      fn: function(scope) {
        return [_c('span', [_vm._v(" " + _vm._s(scope.item.nds) + " ")])]
      }
    }, {
      key: "status",
      fn: function(scope) {
        return [(scope.item.status) ? _c('span', {
          style: ('color: ' + scope.item.status.color + ';')
        }, [_vm._v(" " + _vm._s(scope.item.status.name) + " ")]) : _c('span', [_vm._v(" Не указан ")])]
      }
    }, {
      key: "trackig",
      fn: function(scope) {
        return [(scope.item.from_trackig) ? _c('div', {
          staticClass: "route-list-item"
        }, [(scope.item.from_trackig.route_list) ? _c('md-tooltip', {
          attrs: {
            "md-direction": "bottom"
          }
        }, [_vm._v(" " + _vm._s(_vm.getRLStatus(scope.item.from_trackig.route_list.status_id)) + " ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "from label"
        }, [_vm._v(" Забор ")]), _vm._v(" "), (scope.item.from_trackig.route_list_id) ? _c('span', {
          staticClass: "route-list"
        }, [_vm._v(" " + _vm._s('МЛ ' + scope.item.from_trackig.route_list_id) + " ")]) : _c('span', {
          staticClass: "route-list"
        }, [_vm._v(" Без МЛ ")]), _vm._v(" "), _c('span', {
          staticClass: "date"
        }, [_vm._v(" " + _vm._s(_vm.moment(scope.item.from_trackig.date).tz(_vm.$root.userTimezone).format('DD.MM.YYYY')) + " ")]), _vm._v(" "), (scope.item.from_trackig.responsible) ? _c('span', {
          staticClass: "forwarder"
        }, [_vm._v(" " + _vm._s((scope.item.from_trackig.responsible.fio) ? scope.item.from_trackig.responsible.fio : scope.item.from_trackig.responsible.login) + " ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (scope.item.to_trackig) ? _c('div', {
          staticClass: "route-list-item"
        }, [(scope.item.to_trackig.route_list) ? _c('md-tooltip', {
          attrs: {
            "md-direction": "bottom"
          }
        }, [_vm._v(" " + _vm._s(_vm.getRLStatus(scope.item.to_trackig.route_list.status_id)) + " ")]) : _vm._e(), _vm._v(" "), _c('span', {
          staticClass: "to label"
        }, [_vm._v(" Выдача ")]), _vm._v(" "), (scope.item.to_trackig.route_list_id) ? _c('span', {
          staticClass: "route-list"
        }, [_vm._v(" " + _vm._s('МЛ ' + scope.item.to_trackig.route_list_id) + " ")]) : _c('span', {
          staticClass: "route-list"
        }, [_vm._v(" Без МЛ ")]), _vm._v(" "), _c('span', {
          staticClass: "date"
        }, [_vm._v(" " + _vm._s(_vm.moment(scope.item.to_trackig.date).tz(_vm.$root.userTimezone).format('DD.MM.YYYY')) + " ")]), _vm._v(" "), (scope.item.to_trackig.responsible) ? _c('span', {
          staticClass: "forwarder"
        }, [_vm._v(" " + _vm._s((scope.item.to_trackig.responsible.fio) ? scope.item.to_trackig.responsible.fio : scope.item.to_trackig.responsible.login) + " ")]) : _vm._e()], 1) : _vm._e()]
      }
    }]),
    model: {
      value: (_vm.reports),
      callback: function($$v) {
        _vm.reports = $$v
      },
      expression: "reports"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.canPrintNoForwardingReport) ? _c('z-button', {
    on: {
      "click": _vm.printNoForwardingReport
    }
  }, [_vm._v(" Распечатать ")]) : _vm._e()], 1)], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bb5cd39c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/reports/views/NoForwardingReport.vue
// module id = 1248
// module chunks = 0